<template>
    <div>
        <h1 class="subtitle">Mixers</h1>
        <div class="nj-cols">
            <div class="nj-card">
                <div class="nj-subtitle-1">Filtros</div>
                <div class="nj-cols form c3">
                    <div>
                        <div class="nj-label">Nombre</div>
                        <input type="text" class="nj-text" v-model="filters.mix_nombre" placeholder="" @keyup.enter="buscar()" ref="first">
                    </div>
                    <div>
                        <div class="nj-label">Placa</div>
                        <input type="text" class="nj-text" v-model="filters.mix_placa" placeholder="" @keyup.enter="buscar()">
                    </div>
                    <div>
                        <div class="nj-label">Estado</div>
                        <select class="nj-select" v-model="filters.est_id" @change="buscar()">
                            <option value="null">todos los estados</option>
                            <option v-for="item in estados" :key="item.est_id" :value="item.est_id">{{ item.est_nombre }}</option>
                        </select>
                    </div>
                </div>
                <Buttons line>
                    <button class="nj-button" @click="buscar()">Buscar</button>
                    <button class="nj-button c-green" @click="popup({ componente: 'registrar', abrir: true })">Nuevo</button>
                </Buttons>
            </div>
            <div class="nj-card">
                <b-table :data="mixers" :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage" :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition" :default-sort-direction="defaultSortDirection" :pagination-rounded="isPaginationRounded" :sort-icon="sortIcon" :sort-icon-size="sortIconSize" aria-next-label="Next page"
                    aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
                    <template slot-scope="props">
                        <b-table-column label="ID" header-class="is-info">{{ props.row.mix_id }}</b-table-column>
                        <b-table-column label="Mixer" header-class="is-info">{{ props.row.mix_nombre }}</b-table-column>
                        <b-table-column label="Placa" header-class="is-info">{{ props.row.mix_placa }}</b-table-column>
                        <b-table-column label="Capacidad" header-class="is-info">{{ props.row.mix_capacidad }}</b-table-column>
                        <b-table-column label="Estado" header-class="is-info">
                            <b-field>
                                <b-tag :class="tagEstado(props.row.est_id)">{{ props.row.est_nombre }}</b-tag>
                            </b-field>
                        </b-table-column>
                        <b-table-column label="Opciones" header-class="is-info">
                            <div class="nj-flx">
                                <button class="nj-button icon c-blue" @click="popup({ componente: 'ver', abrir: true, mix_id: props.row.mix_id })" title="Ver"><i class="mdi-information"></i></button>
                                <button class="nj-button icon" @click="popup({ componente: 'modificar', abrir: true, mix_id: props.row.mix_id })" title="Modificar"><i class="mdi-pencil"></i></button>
                            </div>
                        </b-table-column>
                    </template>
                </b-table>
            </div>
        </div>
        <RegistrarMixer v-if="activarRegistrar" @close="popup($event)" :mix_id="mix_id"></RegistrarMixer>
        <VerMixer v-if="activarVer" @close="popup($event)" :mix_id="mix_id"></VerMixer>
        <ModificarMixer v-if="activarModificar" @close="popup($event)" :mix_id="mix_id"></ModificarMixer>
    </div>
</template>
<script>
import Toast from "../../util/toast"
import Keyboard from "../../util/keyboard"
import { AppService, MixerService, ResponseStatus } from "../../services"
import { Buttons } from "./../components"
import Arrays from "../../util/arrays"
import RegistrarMixer from "./RegistrarMixer.vue"
import VerMixer from "./VerMixer.vue"
import ModificarMixer from "./ModificarMixer.vue"

export default {
    name: "Mixer",
    components: {
        Buttons,
        RegistrarMixer,
        VerMixer,
        ModificarMixer,
    },
    data() {
        return {
            estados: [],
            filters: {
                mix_id: null,
                mix_placa: null,
                mix_nombre: null,
                est_id: null,
            },
            mixers: [],
            mix_id: null,
            activarRegistrar: false,
            activarVer: false,
            activarModificar: false,
            isPaginated: true,
            isPaginationSimple: false,
            isPaginationRounded: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            currentPage: 1,
            perPage: 10,
        }
    },
    methods: {
        buscar() {
            MixerService.buscar({
                mixer: this.filters
            }).then(
                response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.mixers = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        tagEstado(id) {
            return this.estados.find((item) => item.est_id == id).styles
        },
        popup({ componente, abrir, buscar = false, mix_id = null }) {
            this.mix_id = mix_id
            switch (componente) {
                case "registrar":
                    // registrar 
                    this.activarRegistrar = abrir
                    break
                case "ver":
                    // ver
                    this.activarVer = abrir
                    break
                case "modificar":
                    // modificar
                    this.activarModificar = abrir
                    break
                case "all":
                    // cerrar todo
                    this.activarRegistrar = false
                    this.activarVer = false
                    this.activarModificar = false
                    break
            }
            if (buscar) {
                this.buscar()
            }
        },
    },
    mounted() {
        AppService.getData(["estados"]).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.estados = Arrays.filter(response.data.estados, "est_codigo", ["activo", "inactivo"])
                    this.buscar()
                }
                else {
                    Toast.error(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
        this.$refs.first.focus()
    }
}
</script>

<style scoped></style>